import React, { useEffect, useState } from "react";
import { MultiSelect, SegmentedControl, Select } from "@mantine/core";
import { pressKey, pressKeyFirefox } from "./dataPressKey";

const PressKey = (props) => {
    const [options, setOptions] = useState({
        pressKey: props?.nodeData?.data?.options?.pressKey ?? [],
        type: props?.nodeData?.data?.options?.type ?? 'PRESS',
        browser: props?.nodeData?.data?.options?.browser ?? 'chrome',
    });

    const onSelectChange = (key) => (value) => {
        const newOptions = { ...options, [key]: value }
        setOptions(newOptions);
    }

    useEffect(() => {
        props.handleSetDataBaseModal(options);
    }, [options])

    return (
        <>
            <div style={{ textAlign: 'center' }}>
                <SegmentedControl
                    data={[
                        { label: 'Chrome', value: 'chrome' },
                        { label: 'Firefox', value: 'firefox' },
                    ]}
                    value={options.browser}
                    onChange={(browser) => setOptions({...options, browser})}
                />
            </div>
            <MultiSelect
                data={options.browser === 'chrome' ?pressKey : pressKeyFirefox}
                placeholder="Keys"
                label="Select key(s)"
                searchable
                nothingFound="Nothing found"
                value={options.pressKey}
                onChange={onSelectChange('pressKey')}
            />
            <Select
                label="Type press"
                data={[
                    { value: 'PRESS', label: 'PRESS' },
                    { value: 'DOWN', label: 'DOWN' },
                    { value: 'UP', label: 'UP' },
                ]}
                style={{ marginTop: '8px' }}
                value={options.type}
                onChange={onSelectChange('type')}
            />
        </>
    )
}

export default PressKey;
